import VisualRadioList from '@/atoms/forms/radio/VisualRadioList';
import CustomMarkdown from '@/molecules/CustomMarkdown';
import ModalClassicLayout from 'context/Modal/layout/Classic';
import { useTranslation } from 'react-i18next';
import Image from 'utils/Image';
import useCloseTumultEvents from './useCloseTumultEvents';
import { FormProvider } from 'react-hook-form';
import AlertTool from '@/molecules/AlertTool';
import { VARIANT_COLOR_ENUM } from '@/types/utils';

type Props = {
  closeModal: () => void;
  eventId: string;
};

const CloseTumultEvent = ({ closeModal, eventId }: Props) => {
  const { t } = useTranslation();

  const { factionsOptions, handleSubmit, formMethods, isLoading, cms } = useCloseTumultEvents({ eventId });

  return (
    <ModalClassicLayout
      closeModal={closeModal}
      isLoadingContent={isLoading}
      onSubmit={handleSubmit}
      title={t('event.admin.modal.closeEventTitle')}
    >
      <FormProvider {...formMethods}>
        {cms && (
          <form className="flex flex-col gap-4">
            {cms.tooltip && (
              <AlertTool icon="fa-solid fa-circle-info" variant={VARIANT_COLOR_ENUM.INFO}>
                <CustomMarkdown className="p-0">{cms.tooltip}</CustomMarkdown>
              </AlertTool>
            )}
            <CustomMarkdown>{cms.displayText || ''}</CustomMarkdown>
            {cms.foreground?.image && (
              <Image
                alt={cms.foreground?.image.alt}
                className="m-auto"
                height={Number(cms.foreground?.image.sizes['medium-height'])}
                src={cms.foreground?.image.sizes.large}
                width={Number(cms.foreground?.image.sizes['medium-width'])}
              />
            )}
            <div>
              <p className="sm-medium text-neutral-700">{t('modal.closeTumult.factionLabel')}</p>
              <VisualRadioList
                name="faction"
                options={factionsOptions}
                supportingText={t('modal.closeTumult.factionSupporting')}
              />
            </div>
            <input className="hidden" type="submit" />
          </form>
        )}
      </FormProvider>
    </ModalClassicLayout>
  );
};

export default CloseTumultEvent;
